const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/fleet-management/vehicles/$vehicleId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { createSearchValidator } from '@/lib/search-validators';
import { VEHICLE_DETAIL_TABS } from '@/features/fleet-management/vehicle/model/vehicle-detail-tab';
export const Route = createFileRoute('/_app/fleet-management/vehicles/$vehicleId')({
  validateSearch: createSearchValidator<Record<never, string | undefined>, VehicleDetailTab>({
    tabs: VEHICLE_DETAIL_TABS,
    filterKeys: []
  }),
  staticData: {
    breadCrumb: 'Vehicle Detail'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/** Which data tab an attribute's card lives on — resolves the cross-tab blocked-save line to the tab a `setTab` call should open. */